import React, { useState, useEffect } from "react";
import axios from "../../axios";
import { get } from "lodash";
import { connect } from "react-redux";
import * as actionTypes from "../../store/actions";
import { Field, Form, Formik } from "formik";
import "react-datepicker/dist/react-datepicker.css";
import "./cmsManagement.css";
import Cookies from "js-cookie";
import { Icons, toast } from "react-toastify";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import JoditEditor from "jodit-react";
import * as Yup from "yup";

import Input from "../../components/Input";
import { Modal } from "../../components/Modal";
import Overlay from "../../components/Overlay";
import TextArea from "../../components/TextArea";

import { subAdminValidator } from "../../utils/validators";
import { RxCross2 } from "react-icons/rx";
import {
    extractDate,
    uploadImage,
    subadminAccessChange,
} from "../../utils/functions";

// Mui & material UI
import { makeStyles } from "@material-ui/core/styles";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";

// React Icons
import { HiArrowNarrowLeft } from "react-icons/hi";

// Elements
import {
    DashboardContainer,
    DashboardWrapper,
    DashboardHeading,
    DashHeading,
    Button,
    Fields,
    ProfileDetailForm,
} from "./CMSElement";
import { FaQ } from "react-icons/fa6";

const useStyles = makeStyles((theme) => ({
    paperTableHeight: {
        width: "97%",
        marginLeft: "1rem",
        // minHeight: "87vh",
        border: "1px solid rgba(12, 45, 6, 0.10)",
        borderRadius: "10px",
    },
}));

const CreateFAQs = ({ setUsers, userData }) => {
    const classes = useStyles();

    const location = useLocation();
    const faq = location.state?.faq; // Retrieve FAQ data if passed

    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const [deleteModal, setDeleteModal] = useState(false);

    // Handle Create & Update FAQs
    const handleSubmit = async (values) => {
        setIsLoading(true);
        try {
            const apiCall = faq
                ? axios.put(`/private/updateFAQ/${faq._id}`, values)
                : axios.post(`/private/createFaq`, values);

            const { data } = await apiCall;
            toast.success(data?.message);
            navigate("/fAQs"); // Navigate back to FAQ Management
        } catch (error) {
            handleErrorResponse(error);
        } finally {
            setIsLoading(false);
        }
    };

    // Error Handle
    const handleErrorResponse = (error) => {
        const status = error?.response?.status;
        const message = error?.response?.data?.message || "";

        if (status === 422) {
            toast.error(message, { position: toast.POSITION.TOP_RIGHT });
        } else if (error?.response?.status === 901) {
            subadminAccessChange(navigate);
            toast.error(`${error.response.data?.message}`, {
                position: "top-right",
            });
        } else if (status === 419) {
            localStorage.clear();
            Cookies.remove("showProfileSidebar");
            setUsers("");
            toast.error(message, { position: toast.POSITION.TOP_RIGHT });
            navigate("/");
        } else {
            toast.error(message, { position: toast.POSITION.TOP_RIGHT });
        }
    };


    const validationSchema = Yup.object().shape({
        question: Yup.string()
            .trim()
            .matches(/^(?!\s*$).*$/, "This field cannot contain spaces. Please enter a valid value.") // No empty spaces
            .min(2, "Question must be at least 2 characters.")
            .max(200, "Question cannot exceed 200 characters.")
            .required("Question is required."),

        answer: Yup.string()
            .trim()
            .matches(/^(?!\s*$).*$/, "This field cannot contain spaces. Please enter a valid value.") // No empty spaces
            .min(2, "Answer must be at least 2 characters.")
            // .max(1000, "Answer cannot exceed 1000 characters.")
            .required("Answer is required."),

        userType: Yup.string().required("User Type is required."),
    });

    return (
        <>
            <DashboardContainer>
                <DashboardWrapper>
                    <ProfileDetailForm>
                        <div
                            style={{ cursor: "pointer" }}
                            className="d-flex align-items-center"
                            onClick={() => {
                                navigate("/fAQs"); // Navigate back to FAQ Management
                            }}
                        >
                            <HiArrowNarrowLeft style={{ fontSize: "1.2rem" }} />
                            <div className="common-heading ps-2">Manage FAQs</div>
                        </div>


                        {/* Form Code */}
                        <DashboardHeading>
                            <Formik
                                enableReinitialize
                                initialValues={{
                                    question: faq?.question || "",
                                    answer: faq?.answer || "",
                                    userType: faq?.userType || "",
                                }}
                                validationSchema={validationSchema} // <-- Apply validation schema here
                                onSubmit={handleSubmit}
                            >
                                {({ values, handleChange, setFieldValue, errors, touched, setFieldError, submitForm, validateForm, setFieldTouched }) => (
                                    <Form
                                        style={{
                                            width: "100%",
                                            display: "flex",
                                            flexDirection: "column",
                                            gap: "1rem",

                                        }}
                                    >
                                        <div>
                                            <FormControl>
                                                <FormLabel>User Type</FormLabel>
                                                <RadioGroup
                                                    row
                                                    name="userType"
                                                    value={values.userType}
                                                    onChange={handleChange}
                                                >
                                                    <FormControlLabel
                                                        value="serviceProvider"
                                                        control={<Radio />}
                                                        label="Job Host"
                                                    />
                                                    <FormControlLabel
                                                        value="user"
                                                        control={<Radio />}
                                                        label="Job Seeker"
                                                    />
                                                </RadioGroup>
                                            </FormControl>
                                            {errors.userType && touched.userType && (
                                                <div style={{ color: "red" }}>{errors.userType}</div>
                                            )}
                                        </div>
                                        <div className="faq-section">
                                            <FormLabel>Question</FormLabel>
                                            <TextArea
                                                name="question"
                                                className="form-control"
                                                placeholder="Type your question here..."
                                                value={values.question}
                                                onChange={handleChange}
                                            />
                                            {errors.question && touched.question && (
                                                <div style={{ color: "red" }}>{errors.question}</div>
                                            )}
                                        </div>
                                        <div className="faq-section">
                                            <FormLabel>Answer</FormLabel>
                                            {/* <JoditEditor
                                                config={{
                                                    askBeforePasteFromWord: false,
                                                    askBeforePasteHTML: false,
                                                    readonly: false,
                                                    placeholder: "Type your answer here...",
                                                }}
                                                value={values.answer}
                                                onBlur={(newContent) => {
                                                    const tempDiv = document.createElement("div");
                                                    tempDiv.innerHTML = newContent;
                                                    let plainText = tempDiv.textContent || tempDiv.innerText || "";
                                                    plainText = plainText.replace(/\u00A0/g, " ").replace(/\s+/g, " ").trim(); // Replace non-breaking & multiple spaces
                                                    setFieldValue("answer", plainText);
                                                }}
                                            /> */}


                                            <FormLabel>Answer</FormLabel>
                                            <JoditEditor
                                                config={{
                                                    askBeforePasteFromWord: false,
                                                    askBeforePasteHTML: false,
                                                    readonly: false,
                                                    placeholder: "Type your answer here...",
                                                }}
                                                value={values.answer}
                                                onBlur={(newContent) => {
                                                    // Save the HTML content directly, not plain text
                                                    setFieldValue("answer", newContent);
                                                }}
                                            />



                                            {errors.answer && touched.answer && (
                                                <div style={{ color: "red" }}>{errors.answer}</div>
                                            )}
                                        </div>
                                        <div
                                            style={{
                                                display: "flex",
                                                alignItems: "center",
                                                gap: "1rem",
                                            }}
                                        >
                                            <Button
                                                type="button"
                                                disabled={isLoading}
                                                style={{ background: "#5088FB" }}
                                                onClick={async () => {
                                                    const errors = await validateForm();
                                                    const hasErrors = Object.keys(errors).length > 0;

                                                    if (hasErrors) {
                                                        // Force show all validation errors
                                                        Object.keys(errors).forEach((field) => {
                                                            setFieldTouched(field, true, false);
                                                        });
                                                    } else {
                                                        setDeleteModal(true); // Show modal only if no validation errors
                                                    }
                                                }}
                                            >
                                                {isLoading ? "Saving..." : faq ? "Update" : "Create"}
                                            </Button>
                                        </div>




                                        {/* Save Confirmation Modal */}
                                        <Modal
                                            maxWidth="lg"
                                            width="360px"
                                            RoundedCorners={true}
                                            isOpen={deleteModal}
                                            onClose={() => setDeleteModal(false)}
                                            backgroundModal={false}
                                            backgroundModalContent={false}
                                            title={
                                                <div>
                                                    <div className="d-flex align-items-center justify-content-end">
                                                        <RxCross2
                                                            style={{ cursor: "pointer" }}
                                                            onClick={() => setDeleteModal(false)}
                                                        />
                                                    </div>
                                                    <p className="profile-section-text">Save</p>
                                                    <div className="logout-header" style={{ paddingTop: "0px" }}>
                                                        Are you sure you want to save this FAQ? Please confirm that you want to save
                                                    </div>
                                                </div>
                                            }
                                            content={
                                                <div className="logout-button-group">
                                                    <div
                                                        className="cancel-button"
                                                        onClick={() => setDeleteModal(false)}
                                                    >
                                                        Cancel
                                                    </div>

                                                    <Button
                                                        type="button"
                                                        style={{ width: "130px", backgroundColor: "#5088FB" }}
                                                        // disabled={isLoading || isDisabled}
                                                        onClick={() => {
                                                            setDeleteModal(false); // Close the modal
                                                            submitForm();        // Trigger Formik submission
                                                        }}
                                                    >
                                                        {isLoading ? "Saving..." : "Save"}
                                                    </Button>
                                                </div>
                                            }
                                        />
                                    </Form>
                                )}
                            </Formik>
                        </DashboardHeading>
                    </ProfileDetailForm>
                </DashboardWrapper>
            </DashboardContainer>

            {isLoading && <Overlay />}
        </>
    );
};

const mapStateToProps = (state) => {
    return {
        userData: state.userData,
        locationData: state.locations,
        defaultState: state.defaultState,
        sidebar: state.sidebar,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setUsers: (updatedValue) => {
            dispatch({
                type: actionTypes.UPDATE_USER,
                updatedUser: updatedValue,
            });
        },
        setDefaultState: (updatedValue) => {
            dispatch({
                type: actionTypes.UPDATE_DEFAULT,
                updateDefault: updatedValue,
            });
        },
        setSidebar: (updatedValue) => {
            dispatch({
                type: actionTypes.UPDATE_SIDEBAR,
                updateSidebar: updatedValue,
            });
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(CreateFAQs);
